var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('支付方式')))]),_c('PayWaysBtn',{attrs:{"noHasPayment":_vm.noHasPayment},on:{"selectpayment":_vm.selectPayment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }